import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Typography, Button } from '@material-ui/core';

// CONSTANTS
import { LOCATIONS_HOME_PAGE } from '@/constants/locations';

// UTILITY
import { analyticsClickedCreateProfile } from '@/utility/analytics';

// STORE
import { AuthActions } from '@/store/actions';

// STYLES
import { Container } from './styles';

const CreateFreeProfile = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();

  const handleClick = () => {
    const properties = {
      location: LOCATIONS_HOME_PAGE,
    };

    analyticsClickedCreateProfile(properties);
    dispatch(AuthActions.authDrawerOpen.action({ data: { screen: 'registration' } }));
  };

  return (
    <Container className="create-free-profile section section--green content-visibility--auto">
      <div className="page-content">
        <Typography variant="h3" align="center">
          {t('home.createFreeProfile.title')}
        </Typography>
        <Typography className="p3 m-t-15" variant="inherit" component="p" align="center">
          {t('home.createFreeProfile.subtitle')}
        </Typography>
        <Button
          className="create-free-profile__button"
          variant="contained"
          color="secondary"
          onClick={handleClick}
          fullWidth
        >
          {t('buttons.signUp')}
        </Button>
      </div>
    </Container>
  );
};

export default React.memo(CreateFreeProfile);
